const faculties = [
    "มหาวิทยาลัยเชียงใหม่",
    "คณะมนุษยศาสตร์",
    "คณะศึกษาศาสตร์",
    "คณะวิจิตรศิลป์",
    "คณะสังคมศาสตร์",
    "คณะวิทยาศาสตร์",
    "คณะวิศวกรรมศาสตร์",
    "คณะแพทยศาสตร์",
    "คณะเกษตรศาสตร์",
    "คณะทันตแพทยศาสตร์",
    "คณะเภสัชศาสตร์",
    "คณะเทคนิคการแพทย์",
    "คณะพยาบาลศาสตร์",
    "คณะอุตสาหกรรมเกษตร",
    "คณะสัตวแพทยศาสตร์",
    "คณะบริหารธุรกิจ",
    "คณะเศรษฐศาสตร์",
    "คณะสถาปัตยกรรมศาสตร์",
    "คณะการสื่อสารมวลชน",
    "คณะรัฐศาสตร์และรัฐประศาสนศาสตร์",
    "คณะนิติศาสตร์",
    "วิทยาลัยศิลปะ สื่อ และเทคโนโลยี",
    "คณะสาธารณสุขศาสตร์",
    "วิทยาลัยการศึกษาและการจัดการทางทะเล",
    "วิทยาลัยนานาชาตินวัตกรรมดิจิทัล",
    "สถาบันนโยบายสาธารณะ",
    "สถาบันวิศวกรรมชีวการแพทย์",
    "บัณฑิตวิทยาลัย",
    "สำนักหอสมุด",
    "สำนักทะเบียนและประมวลผล",
    "สำนักบริการเทคโนโลยีสารสนเทศ",
    "สำนักบริการวิชาการ",
    "สำนักส่งเสริมศิลปวัฒนธรรม",
    "สถาบันวิจัยวิทยาศาสตร์สุขภาพ",
    "สถาบันวิจัยสังคม",
    "สถาบันวิจัยวิทยาศาสตร์และเทคโนโลยี",
    "สำนักพัฒนาคุณภาพการศึกษา",
    "สำนักงานมหาวิทยาลัย",
    "สำนักงานสภามหาวิทยาลัย",
    "ศูนย์สัตว์ทดลอง",
    "สถาบันวิจัยและพัฒนาพลังงานนครพิงค์",
    "ศูนย์วิจัยข้าวล้านนา",
    "สถาบันภาษา",
    "สถาบันวิจัยเทคโนโลยีหลังการเก็บเกี่ยว",
    "ศูนย์นวัตกรรมอาหารและบรรจุภัณฑ์",
    "อุทยานวิทยาศาสตร์และเทคโนโลยี",
    "สำนักงานการตรวจสอบภายใน",
    "วิทยาลัยนานาชาติ",
    "สถาบันพิภพวิทยา",
    "ศูนย์ศรีพัฒน์",
    "อื่นๆ"
];

export { faculties };